<template>
  <div class="imagesRecordPage">
    <div class="tableCont">
      <Table size="small" :columns="columns" :dataSource="tableData" border rowKey="id" :pagination="false">
        <template slot="total_sequence_size" slot-scope="text, record">
          <a class="newLink" @click="showImageSequence(record)">{{record.total_sequence_size}}</a>
        </template>
        <template slot="status" slot-scope="text, record">
          <span v-if="record.status === 0">解绑</span>
          <span v-if="record.status === 1">匹配</span>
          <span v-if="record.status === 2">重传</span>
        </template>
      </Table>
    </div>
    <div class="footer">
      <div class="buttonCont">
        <Button size="large" @click="closeImagesRecord">返回</Button>
      </div>
    </div>
    <Modal v-model="sequenceDetailFlag" title="影像序列明细" :footer="null" :forceRender="false" :width='700'>
      <sequenceDetails v-if="sequenceDetailFlag" @closeSequenceDetails=closeSequenceDetails :sequenceDetails="sequenceDetails"></sequenceDetails>
    </Modal>
  </div>
</template>

<script>
import { Table, Button, Modal } from 'ant-design-vue'
import sequenceDetails from '../../components/sequenceDetails'
import { getImagesRecord } from '../../api/mateImage'
export default {
  props: {
    orderCheckId: {
      type: Number,
      default: 0
    }
  },
  components: {
    Table,
    Button,
    Modal,
    sequenceDetails
  },
  data () {
    return {
      columns: [
        { title: '系统接收影像时间', dataIndex: 'receive_time' },
        { title: '影像号', dataIndex: 'film_no' },
        { title: '序列数量', dataIndex: 'total_sequence_size', scopedSlots: { customRender: 'total_sequence_size' } },
        { title: '图片数量', dataIndex: 'total_image_size' },
        { title: '变更操作', dataIndex: 'status', scopedSlots: { customRender: 'status' } },
        { title: '变更原因', dataIndex: 'change_reason' },
        { title: '变更时间', dataIndex: 'change_time' },
        { title: '操作人', dataIndex: 'creator' }
      ],
      tableData: [],
      sequenceDetailFlag: false,
      sequenceDetails: ''
    }
  },
  async mounted () {
    await this.initData()
  },
  methods: {
    async initData () {
      let data = await getImagesRecord({ orderCheckId: this.orderCheckId })
      if (data) this.tableData = data
    },
    closeImagesRecord () {
      this.$emit('closeImagesRecord')
    },
    showImageSequence (record) {
      this.sequenceDetails = record.image_list_detail
      this.sequenceDetailFlag = true
    },
    closeSequenceDetails () {
      this.sequenceDetailFlag = false
    }
  }
}
</script>

<style lang="less">
@import url('../../style/index.less');
.imagesRecordPage{
  .tableCont{
    height: 240px;
    overflow-y: auto;
    .newLink{
      text-decoration: underline;
      padding: 20px;
    }
  }
  .footer{
    .modalFooter();
  }
}
</style>